module.exports = __webpack_public_path__ + "img/Empty.63c7edea.png";